import {Component, OnInit, ViewChild} from '@angular/core';
import {DeviceService} from '../services/device.service';
import {SwalComponent} from '@sweetalert2/ngx-sweetalert2';
import {FirmService} from '../services/firm.service';
import {Router} from '@angular/router';
import {NgxSpinnerService} from 'ngx-spinner';

declare var $: any;

@Component({
    selector: 'app-device-log',
    templateUrl: './device-log.component.html',
    styleUrls: ['./device-log.component.scss']
})
export class DeviceLogComponent implements OnInit {

    searchFirm = null;
    searchText;
    limit = 25;
    page = 1;
    pages = 2;
    selector: string = '.error-list';
    errorList = [];
    firmSelectList = [];
    filter = {};
    @ViewChild('errorSwal') private errorSwal: SwalComponent;
    @ViewChild('successSwal') private successSwal: SwalComponent;

    constructor(
        private deviceService: DeviceService,
        private firmService: FirmService,
        private router: Router,
        private spinner: NgxSpinnerService
    ) {
    }

    ngOnInit() {
        this.getAllFirms();
        this.getAllErrorLog(this.page, this.limit, this.filter);
    }

    onSearchText(e) {
        this.searchText = e;
        this.page = 1;
        this.filter['serialNumber'] = this.searchText;
        if (this.searchText == '') {
            delete this.filter['serialNumber'];
        }
        this.getAllErrorLog(this.page, this.limit, this.filter);
    }

    onSelectFirm(value) {
        this.searchFirm = value;
        this.page = 1;
        this.filter['firm'] = this.searchFirm;
        console.log(this.searchFirm);
        if (this.searchFirm == 'null') {
            delete this.filter['firm'];
        }
        this.getAllErrorLog(this.page, this.limit, this.filter);
    }


    downloadFile(fileName) {
        this.spinner.show();
        this.deviceService.downloadErrorFile(fileName).subscribe((res) => {
            this.spinner.hide();

            const url = window.URL.createObjectURL(res);
            const a = document.createElement('a');
            document.body.appendChild(a);
            a.setAttribute('style', 'display: none');
            a.href = url;
            a.target = '_black';
            a.download = fileName;
            a.click();
            window.URL.revokeObjectURL(url);
            a.remove();
        }, error => {
            this.spinner.hide();

            this.errorSwal.title = 'Dosya İndirilemedi!';
            this.errorSwal.show();
        });
    }

    getAllErrorLog(page, limit, filter) {
        this.deviceService.getAllDeviceLog({page, limit}
            , filter)
            .subscribe(response => {
                $('#page-loader').fadeOut();
                if (page === 1) {
                    this.errorList = response.docs;
                } else {
                    for (const item of response.docs) {
                        this.errorList.push(item);
                    }
                }

                console.log(this.errorList);
                this.pages = response.pages;
            }, error => {
                $('#page-loader').fadeOut();
                this.errorSwal.text = 'Ürünlerin devamı yüklenemedi!';
                this.errorSwal.show();
            });
    }

    onScroll() {
        if (this.page + 1 > this.pages) {
            return;
        }
        $('#page-loader').fadeIn();
        this.page += 1;
        this.deviceService.getAllDeviceLog({page: this.page, limit: this.limit}
            , this.filter)
            .subscribe(response => {
                $('#page-loader').fadeOut();
                for (const item of response.docs) {
                    this.errorList.push(item);
                }
                this.pages = response.pages;
            }, error => {
                $('#page-loader').fadeOut();
                this.errorSwal.text = 'Ürünlerin devamı yüklenemedi!';
                this.errorSwal.show();
            });
    }


    getAllFirms() {
        this.spinner.show();
        this.firmService.getAllFirms().subscribe(res => {
            if (res.success) {
                for (const firm of res.firms) {
                    if (firm._id) {
                        this.firmSelectList.push({
                            _id: firm._id,
                            name: firm.name
                        });
                    }
                }
            }
            this.spinner.hide();
        }, error => {
            this.spinner.hide();
            if (error.message === 'Error: Access Denied') {
                localStorage.removeItem('token');
                localStorage.removeItem('user');
                this.router.navigate(['/login']);
            } else {
                this.errorSwal.title = error.status;
                this.errorSwal.text = error.error;
                this.errorSwal.show();
            }
        });
    }

}



// WEBPACK FOOTER //
// /home/escobar/Documents/Projects/E-VEND/Srl-Evend/FE/superadmin/src/app/device-log/device-log.component.ts